// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width: 1280px){.dashboard-logo{display:none !important}}@media only screen and (max-width: 1280px){.navigation-web .navbar.dashboard{padding:0}}.modal_content{width:1340px;max-width:1340px;padding:20px;border-radius:4px;background-color:#fff;z-index:1040}@media only screen and (max-width: 1340px){.modal_content{width:1230px !important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
